module.exports = __webpack_public_path__ + "images/paper-add.1782880901430.png";